export const MORE_LIKE_THIS_PENDING = 'MLT/MORE_LIKE_THIS_PENDING';
export const GET_MORE_LIKE_THIS_VEHICLES = 'MLT/GET_MORE_LIKE_THIS_VEHICLES';
export const GET_MORE_LIKE_THIS_VEHICLES_SUCCESS =
  'MLT/GET_MORE_LIKE_THIS_VEHICLES_SUCCESS';
export const GET_MORE_LIKE_THIS_VEHICLES_FAIL =
  'MLT/GET_MORE_LIKE_THIS_VEHICLES_FAIL';
export const SWITCH_LAST_SEARCH = 'SWITCH_LAST_SEARCH';
export const RESET_MORE_LIKE_THIS = 'RESET_MORE_LIKE_THIS';
